import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import Assignee from 'components/sales/formSection/assignee/assignee';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import Images from 'assets/images/imageData';
import { Button } from 'react-bootstrap';
import ModalPop from 'components/sales/modal/modal';
import { Link } from 'react-router-dom';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';

const HotoChangeAssignee = ({
                          getHotoAssigneeList,
                          assigneeList,
                          match,
                          updateHotoAssignee,
                          getAllHotoDetails,
                          hotoDetails

                        }) => {
  const [isFiled, setIsFiled] = useState(false);
  const [siteId, setsiteId] = useState();
  const [isModal, setIsModal] = useState(false);
  const [isRequired, setRequired] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { baseUrl } = useContext(BaseUrl);
  const inputs = {
    assigneeDetail: null,
  };
  const [assigneeData, setAssigneeData] = useState(inputs);
  const [previousIter, setPreviousIter] = useState();
  const [iterCount, setIterCount] = useState();

  useEffect(() => {
    setsiteId(match.params.siteId);
    (async () => {
      if (siteId) {
        setIsLoading(true);
        await getHotoAssigneeList(match.params.team, siteId);
        setIsLoading(false);
      }
    })();
  }, [siteId]);

  useEffect(() => {
    (async () => {
      setIsLoading(true)
      getAllHotoDetails(match.params.siteId);
      setIsLoading(false)
    })()
  }, []);

  useEffect(() => {
    if (hotoDetails && hotoDetails?.prevIter) {
      setPreviousIter(hotoDetails?.prevIter);
      setIterCount(hotoDetails?.prevIter.length);

    }
  }, [hotoDetails])

  const handleAssignee = (val) => {
    setAssigneeData({ ...assigneeData, assigneeDetail: val });
  };

  const handleModalHide = () => setIsModal(false);
  const handleSubmit = async () => {
    const { assigneeDetail } = assigneeData;
    if (assigneeDetail === null) {
      setIsFiled(true);
      setIsModal(false);
      return false;
    } else {
      setIsFiled(false);
      setIsModal(true);
      setIsLoading(true);
      assigneeDetail.team = match.params.team;
      const res = await updateHotoAssignee(assigneeDetail);
      setIsLoading(false);
      if (res) getHotoAssigneeList(match.params.team, siteId);
    }
  };

  const headerBtns = () => {
    return (
      <Button onClick={handleSubmit} className="btn btn-primary">
        {localization.submitDtl}
        <img src={Images?.ArrowRight} alt="" />
      </Button>
    );
  };

  return (
    <Layout
      title={'Assign Engineer'}
      Buttons={headerBtns}
      className={isFiled ? 'requiredFileds' : ''}
      isGoback
      isLoading={isLoading}
    >
      <Assignee
        assigneeList={assigneeList}
        siteId={match.params.siteId}
        handleValue={handleAssignee}
        isBulkAssignment={true}
        showComment={false}
      />

      <br/>
      {/*Previous Hoto Iterations Start*/}
      {
        previousIter &&
        <div className="container-fluid mb-0">
          {previousIter.map((prevIt, key2) => {
            return(
              <div className="card mb-2">
                <div className="card-header mb-3">
                  HOTO Iteration {iterCount-key2}
                  <span className='r-shiwt'>
                  ME: <b>{prevIt?.[0].m_name} ({prevIt?.[0].me_created_at})</b>
                </span>
                  <span className='r-shiwt m-right'>
                  SE: <b>{prevIt?.[0].i_name} ({prevIt?.[0].se_updated_at})</b>
                </span>
                </div>
                <div className="card-body ml-2 mr-2">

                  <table className='panel-table table table-striped mb-2' width="100%">
                    <thead>
                    <tr>
                      <th> Material</th>
                      <th> Maintenance Images</th>
                      <th> Material Status</th>
                      <th> Maintenance Remark</th>
                      <th> Operation Images</th>
                      <th> Operation Remark</th>
                    </tr>
                    </thead>
                    <tbody>
                    {prevIt.map((value, key3) => {
                      // {console.log(value)}
                      return (
                        <tr key={key3}>
                          <td>{value.material_name}</td>
                          <td>
                            {value?.m_image &&
                              <div className='scrollable-img'>
                                {value.m_image.map((imgdoc, j) => {
                                  return (
                                    <a href={imgdoc} target='_blank'>
                                      {imgdoc.split('.').pop() === 'png' ? <> <img src={imgdoc}
                                                                                   style={{
                                                                                     "width": "80px",
                                                                                     "borderRadius": "8px",
                                                                                     "height": "57px",
                                                                                     "border": "1px solid #555"
                                                                                   }}/> <span className="space"></span> </>:
                                        imgdoc.split('.').pop() === 'jpeg' ? <>  <img src={imgdoc}
                                                                                      style={{
                                                                                        "width": "80px",
                                                                                        "borderRadius": "8px",
                                                                                        "height": "57px",
                                                                                        "border": "1px solid #555"
                                                                                      }}/> <span className="space"></span> </>:
                                          imgdoc.split('.').pop() === 'jpg' ? <> <img src={imgdoc}
                                                                                      style={{
                                                                                        "width": "80px",
                                                                                        "borderRadius": "8px",
                                                                                        "height": "57px",
                                                                                        "border": "1px solid #555"
                                                                                      }}/> <span className="space"></span> </>:
                                            imgdoc.split('.').pop() === 'pdf' ?
                                              <> <img src={Images?.DocIcon} alt="" className="view-icon"/> <span className="space"></span> </>:
                                              imgdoc.split('.').pop() === 'doc' ?
                                                <> <img src={Images?.DocIcon} alt="" className="view-icon"/> <span className="space"></span> </>:
                                                ""
                                      }
                                    </a>
                                  );
                                })}
                              </div>
                            }
                          </td>
                          <td>{value?.m_mat_status}</td>
                          <td>{value?.m_remarks}</td>
                          <td>{value?.ins_remarks}</td>
                          <td>
                            {value?.ins_image &&
                              <>
                                <div className='scrollable-img'>
                                  {value.ins_image.map((imgdoc, j) => {
                                    return (
                                      <a href={imgdoc} target='_blank'>
                                        {imgdoc.split('.').pop() === 'png' ? <> <img src={imgdoc}
                                                                                     style={{
                                                                                       "width": "80px",
                                                                                       "borderRadius": "8px",
                                                                                       "height": "57px",
                                                                                       "border": "1px solid #555"
                                                                                     }}/>  <span className="space"></span> </>:
                                          imgdoc.split('.').pop() === 'jpeg' ? <> <img src={imgdoc}
                                                                                       style={{
                                                                                         "width": "80px",
                                                                                         "borderRadius": "8px",
                                                                                         "height": "57px",
                                                                                         "border": "1px solid #555"
                                                                                       }}/> <span className="space"></span> </>:
                                            imgdoc.split('.').pop() === 'jpg' ? <> <img src={imgdoc}
                                                                                        style={{
                                                                                          "width": "80px",
                                                                                          "borderRadius": "8px",
                                                                                          "height": "57px",
                                                                                          "border": "1px solid #555"
                                                                                        }}/> <span className="space"></span> </> :
                                              imgdoc.split('.').pop() === 'pdf' ? <>
                                                  <img src={Images?.DocIcon} alt="" className="view-icon"/> <span className="space"></span> </>:
                                                imgdoc.split('.').pop() === 'doc' ? <>
                                                    <img src={Images?.DocIcon} alt="" className="view-icon"/> <span className="space"></span> </> :
                                                  ""
                                        }
                                      </a>
                                    );
                                  })}
                                </div>
                              </>
                            }
                          </td>

                        </tr>
                      );

                    })}
                    </tbody>
                  </table>
                </div>
              </div>
            );
          })}
        </div>
      }

      {/*Previos Hoto Iterations End*/}

      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.siteAssignSuccess}</h5>
          <Link to={(match.params.team == 1) ? `${baseUrl}/hoto-i-listing/1/1` : `${baseUrl}/hoto-m-listing/2/1`} className="btn btn-primary mb-4">
            {localization.continue} <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

HotoChangeAssignee.propTypes = {};

export default HotoChangeAssignee;
